import React from "react";

const FilledButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <circle cx="8.9999" cy="8.9999" r="7.6" stroke="#C59331" />
      <circle cx="8.9999" cy="8.9999" r="3.6"
        // fill="#C59331" 
        fill="#D3AC5D"
      />
    </svg>
  );
};

export default FilledButton;
